import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Pimprichichwadonlinecab() {



const cardData =
{
  keyword: 'Pimpri Chinchwad Online Cab',
  heading: 'Lotus Cab: Pimpri Chinchwad Online Cab Service',
  headingDescription: 'Lotus Cab offers reliable and professional Pimpri Chinchwad Online Cab services designed for safe, comfortable, and affordable travel across PCMC and nearby cities. Whether you need a local ride within Pimpri, a quick airport transfer from Chinchwad, or a long-distance outstation taxi, our well-maintained fleet of sedan and SUV vehicles ensures a smooth experience. Every trip is managed by trained, background-verified drivers who understand PCMC routes, peak traffic zones, and highway connectivity. We provide transparent pricing, instant online booking confirmation, and 24/7 customer assistance. From corporate commuters and families to daily travelers, Lotus Cab is committed to delivering punctual pickups, clean vehicles, and a stress-free journey every time you book a cab in Pimpri Chinchwad.',

  top: 'Top Places to Visit in Pimpri Chinchwad with Lotus Cab',

  "topPlaces": [
  {
    "title": "Moraya Gosavi Temple, Chinchwad",
    "description": "Moraya Gosavi Temple is one of the most important spiritual landmarks in Chinchwad, attracting devotees throughout the year. Dedicated to Saint Moraya Gosavi, the temple reflects the deep-rooted cultural and religious traditions of the PCMC region. The peaceful atmosphere and devotional energy make it a must-visit spiritual destination. During festivals, thousands of devotees gather here. Lotus Cab provides comfortable and timely cab services for temple visits across Pimpri Chinchwad."
  },
  {
    "title": "Durga Tekdi, Nigdi",
    "description": "Durga Tekdi is a scenic hilltop temple in Nigdi known for its calm environment and panoramic city views. It is a popular destination for morning walks, spiritual visits, and family outings. The elevated location offers a refreshing break from city life. During Navratri and other festivals, it attracts large gatherings. Lotus Cab ensures safe and convenient travel to Durga Tekdi from any location in PCMC."
  },
  {
    "title": "Bird Valley Udyan, Chinchwad",
    "description": "Bird Valley Udyan is a well-maintained garden perfect for families and children. The park features open spaces, play areas, and walking tracks that make it ideal for evening relaxation. Residents of Pimpri Chinchwad frequently visit for leisure time. It is one of the most loved local recreation spots. Lotus Cab offers affordable local cab services for park visits and family outings."
  },
  {
    "title": "Appu Ghar, Nigdi",
    "description": "Appu Ghar is a popular amusement park in Nigdi offering fun rides and entertainment for children and families. It is a favorite weekend destination for PCMC residents. Safe and convenient transportation is important for family trips. Lotus Cab provides punctual and comfortable cab services for visits to Appu Ghar."
  },
  {
    "title": "Auto Cluster Exhibition Center",
    "description": "Auto Cluster Exhibition Center in Chinchwad is a major venue for business expos, industrial events, and corporate gatherings. Professionals frequently travel here for conferences and trade shows. Reliable transport ensures timely arrival for important events. Lotus Cab offers corporate cab services in PCMC with professional drivers and punctual pickups."
  },
  {
    "title": "MCA International Stadium, Gahunje",
    "description": "MCA International Stadium near PCMC is a major cricket venue hosting IPL and international matches. Sports enthusiasts from Pimpri Chinchwad book cabs for hassle-free stadium visits. Event-day traffic can be heavy, requiring experienced drivers. Lotus Cab ensures smooth and timely transportation for match days and events."
  },
  {
    "title": "Elpro City Square Mall",
    "description": "Elpro City Square Mall in Chinchwad is a modern shopping and entertainment hub. It offers retail stores, restaurants, and multiplex cinemas for family entertainment. Many residents prefer cab services for convenient shopping trips. Lotus Cab provides easy and reliable transportation to and from the mall."
  },
  {
    "title": "Sentosa Water Park",
    "description": "Sentosa Water Park near Ravet is a popular destination for fun and relaxation. Families and groups frequently visit during weekends and summer holidays. Comfortable transportation enhances the overall experience. Lotus Cab provides safe and spacious cab options for group outings and family visits."
  },
  {
    "title": "Bhosari MIDC Industrial Area",
    "description": "Bhosari MIDC is a major industrial and corporate hub in PCMC. Business professionals require reliable daily commuting and corporate cab services. Timely pickup and drop are essential for smooth work schedules. Lotus Cab offers dependable corporate taxi services across Pimpri Chinchwad."
  },
  {
    "title": "Akurdi Railway Station",
    "description": "Akurdi Railway Station is an important transit point for PCMC residents. Many travelers require cab services for railway transfers with luggage support. Punctual arrival is crucial for train schedules. Lotus Cab provides timely pickup and drop services to Akurdi and nearby railway stations."
  }
],

  "services": [
    {
      "name": "Pimpri-Chinchwad Online Cab",
      "description": "Book Pimpri-Chinchwad Online Cab with Lotus Cab for instant confirmation and reliable local travel. Our service ensures quick pickup, professional drivers, and clean vehicles across PCMC areas."
    },
    {
      "name": "Pimpri Chinchwad Cab Booking",
      "description": "Easy Pimpri Chinchwad Cab Booking through our online platform with transparent pricing and 24/7 availability."
    },
    {
      "name": "PCMC Online Taxi",
      "description": "Reliable PCMC Online Taxi service for daily commuting, airport transfers, and outstation trips."
    },
    {
      "name": "Pimpri Chinchwad Airport Cab",
      "description": "Timely Pimpri Chinchwad Airport Cab service with flight tracking and punctual pickup."
    },
    {
      "name": "Pimpri Chinchwad Outstation Taxi",
      "description": "Affordable Pimpri Chinchwad Outstation Taxi service with flexible one-way and round-trip options."
    },
    {
      "name": "Pimpri Chinchwad Local Cab Service",
      "description": "Convenient local cab service within PCMC for shopping, office, and daily travel."
    },
    {
      "name": "Best Cab Service PCMC",
      "description": "Top-rated Best Cab Service PCMC offering comfort, reliability, and competitive fares."
    },
    {
      "name": "Affordable Taxi Pimpri",
      "description": "Budget-friendly Affordable Taxi Pimpri service without compromising safety and comfort."
    },
    {
      "name": "Chinchwad Cab Booking Online",
      "description": "Quick Chinchwad Cab Booking Online with instant confirmation and flexible scheduling."
    },
    {
      "name": "PCMC Cab Service 24/7",
      "description": "Round-the-clock PCMC Cab Service 24/7 ensuring availability anytime."
    },
    {
      "name": "Pimpri to Pune Cab",
      "description": "Reliable Pimpri to Pune Cab service with smooth city connectivity."
    },
    {
      "name": "Chinchwad to Airport Taxi",
      "description": "Comfortable Chinchwad to Airport Taxi with punctual departure and luggage support."
    },
    {
      "name": "Online Cab Near Me PCMC",
      "description": "Find Online Cab Near Me PCMC with fast booking and nearby driver allocation."
    },
    {
      "name": "Sedan Cab PCMC",
      "description": "Comfortable Sedan Cab PCMC suitable for individual and small family travel."
    },
    {
      "name": "SUV Taxi Pimpri Chinchwad",
      "description": "Spacious SUV Taxi Pimpri Chinchwad for group and luggage-friendly travel."
    },
    {
      "name": "Corporate Cab PCMC",
      "description": "Professional Corporate Cab PCMC service with punctual travel solutions."
    },
    {
      "name": "Family Trip Cab Pimpri",
      "description": "Safe Family Trip Cab Pimpri with spacious seating and reliable drivers."
    },
    {
      "name": "Cheap Cab in PCMC",
      "description": "Cheap Cab in PCMC offering competitive pricing for budget travel."
    },
    {
      "name": "Luxury Cab Pimpri Chinchwad",
      "description": "Premium Luxury Cab Pimpri Chinchwad service for VIP and executive travel."
    }
  ],

  "tableData": [
    ["Pimpri-Chinchwad Online Cab", "Pimpri Chinchwad Cab Booking"],
    ["PCMC Online Taxi", "Pimpri Chinchwad Airport Cab"],
    ["Pimpri Chinchwad Outstation Taxi", "Pimpri Chinchwad Local Cab Service"],
    ["Best Cab Service PCMC", "Affordable Taxi Pimpri"],
    ["Chinchwad Cab Booking Online", "PCMC Cab Service 24/7"],
    ["Pimpri to Pune Cab", "Chinchwad to Airport Taxi"],
    ["Online Cab Near Me PCMC", "Sedan Cab PCMC"],
    ["SUV Taxi Pimpri Chinchwad", "Corporate Cab PCMC"],
    ["Family Trip Cab Pimpri", "Cheap Cab in PCMC"],
    ["Luxury Cab Pimpri Chinchwad", ""]
  ],

  "whychoose": [
    { "WhyChooseheading": "Reliable PCMC Cab Service", "WhyChoosedescription": "Trusted local cab provider across Pimpri Chinchwad." },
    { "WhyChooseheading": "Transparent Pricing", "WhyChoosedescription": "No hidden charges with clear fare structure." },
    { "WhyChooseheading": "Professional Drivers", "WhyChoosedescription": "Experienced drivers familiar with PCMC routes." },
    { "WhyChooseheading": "24/7 Availability", "WhyChoosedescription": "Round-the-clock booking and support." },
    { "WhyChooseheading": "Multiple Vehicle Options", "WhyChoosedescription": "Sedan and SUV options for every travel need." },
    { "WhyChooseheading": "Airport Transfer Expertise", "WhyChoosedescription": "Timely airport pickups and drops." },
    { "WhyChooseheading": "Corporate Travel Support", "WhyChoosedescription": "Reliable transport solutions for business professionals." },
    { "WhyChooseheading": "Safe & Clean Vehicles", "WhyChoosedescription": "Regularly serviced and sanitized fleet." }
  ]
}

const faqData = [
  { question: 'Does Lotus Cab provide Pimpri Chinchwad Online Cab?', answer: 'Yes, we offer reliable online cab booking services across PCMC.' },
  { question: 'Can I book airport cab from Chinchwad?', answer: 'Yes, we provide timely airport taxi services.' },
  { question: 'Is 24/7 service available in PCMC?', answer: 'Yes, we operate round the clock.' },
  { question: 'Are fares transparent?', answer: 'Yes, we follow clear pricing without hidden charges.' },
  { question: 'Do you provide sedan and SUV options?', answer: 'Yes, both sedan and SUV categories are available.' },
  { question: 'Can I book one-way cab?', answer: 'Yes, one-way and round-trip bookings are available.' },
  { question: 'Is online payment accepted?', answer: 'Yes, we accept online and digital payments.' },
  { question: 'Do you offer corporate cab services?', answer: 'Yes, we provide corporate travel solutions.' },
  { question: 'Are vehicles sanitized?', answer: 'Yes, all vehicles are cleaned before every trip.' },
  { question: 'Can I schedule advance booking?', answer: 'Yes, advance scheduling is available.' }
];

const testimonials = [
  { id: 1, name: 'Mr. Rohit Jadhav', feedback: 'Excellent cab service in PCMC. Driver was punctual and polite.', rating: 5 },
  { id: 2, name: 'Mrs. Neha Kulkarni', feedback: 'Affordable and reliable Pimpri to Pune cab service. Highly recommended.', rating: 5 }
];







































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pimpri Chinchwad Online Cab",
  "image": "https://lotuscab.com/assets/images/pimpri-chinchwad-online-cab.jpg", 
  "description": "Lotus Cab offers Pimpri Chinchwad online cab booking with 24/7 local, airport and outstation taxi services. Book affordable sedan and SUV cabs in PCMC for corporate travel, family trips, and daily commute with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5900"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "10",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pimpri-chinchwad-online-cab"
  }
};








  return (
    <div>
      
<Helmet>
  <title>Contact: +91 8767592195 | Pimpri Chinchwad Online Cab Booking | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Pimpri Chinchwad online cab with Lotus Cab. 24/7 PCMC taxi service for airport, local & outstation travel. Affordable sedan & SUV cab booking. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pimpri-Chinchwad Online Cab, Pimpri Chinchwad Cab Booking, PCMC Online Taxi, Pimpri Chinchwad Airport Cab, Pimpri Chinchwad Outstation Taxi, Pimpri Chinchwad Local Cab Service, Best Cab Service PCMC, Affordable Taxi Pimpri, Chinchwad Cab Booking Online, PCMC Cab Service 24/7, Pimpri to Pune Cab, Chinchwad to Airport Taxi, Online Cab Near Me PCMC, Sedan Cab PCMC, SUV Taxi Pimpri Chinchwad, Corporate Cab PCMC, Family Trip Cab Pimpri, Cheap Cab in PCMC, Luxury Cab Pimpri Chinchwad" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/3.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Pimprichichwadonlinecab;